import { StructuredText } from 'datocms-structured-text-utils'

export const isTwoColumns = (
  body: StructuredText | null,
  separator: string
): boolean => {
  if (!body) return false
  return body?.value?.document.children.filter(
    (item) => item.type === separator
  ).length > 0
    ? true
    : false
}

export const splitBody = (
  body: StructuredText,
  separator: string
): StructuredText[] => {
  const bodies: StructuredText[] = []
  const twoColumnsBody = body?.value?.document.children.reduce(
    (result, item) => {
      if (item.type === separator) {
        result.push([])
      } else {
        result[result.length - 1].push(item)
      }
      return result
    },
    [[]]
  )

  twoColumnsBody.forEach((item) => {
    const newBody = {
      value: { schema: 'dast', document: { type: 'root', children: item } },
      blocks: body.blocks
    } as StructuredText
    bodies.push(newBody)
  })
  return bodies
}
